export default __webpack_public_path__ + "static/media/contact-bg.e246d085.png";